export class HolidayTypeModel {
    id: number = 0;
    name: string = '';
} 